// extracted by mini-css-extract-plugin
export default {"h2":"News_h2__XFcQN","news":"News_news__R9jC-"};